'use strict';

import config from 'config';
import React, { Component } from 'react';
import zChat from 'vendor/web-sdk';
import CardContainer from 'components/CardContainer';
import ActionButton from 'components/ActionButton';
import {connect} from 'react-redux';
import {log} from 'utils';

const { LABELS } = config;

class ChatOverlayRequestTranscript extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: ''
		};

		this.setEmail = this.setEmail.bind(this);
		this.send = this.send.bind(this);
	}

	setEmail(event) {
		this.setState( {
			email: event.target.value
		} );
	}

	onFocusIn(event) {
		const p = event.target.parentNode.parentNode;

		p.classList.add( 'yith-field-filled' )
	}

	onFocusOutocusOut(event) {
		const p = event.target.parentNode.parentNode,
			input = p.querySelector( 'input' );

		if ( ! input.value ) {
			p.classList.remove('yith-field-filled');
		}
	}

	onInvalid( event ) {
		const pInput = event.target.parentNode.parentNode;

		if ( ! pInput ) {
			return;
		}

		pInput.classList.add( 'yith-field-required' );
	}

	send( event ) {
		event.preventDefault();

		// Use HTML form validation to validate inputs
		const form = this.refs.form;

		if ( ! form.checkValidity() ) {
			form.reportValidity();
			return;
		}

		this.props.onClose();
		zChat.sendEmailTranscript( this.state.email, (err) => {
			if ( ! err ) {
				this.props.dispatch({
					type: 'chat',
					detail: {
						timestamp: Date.now(),
						type: 'chat.info',
						info: `${LABELS.transcript_overlay_success || 'We will send a copy of this chat at'} ${this.state.email}`
					}
				});
				log('Error occured >>>', err);
			} else {
				this.props.dispatch({
					type: 'chat',
					detail: {
						timestamp: Date.now(),
						type: 'chat.error',
						info: LABELS.transcript_overlay_error || 'There was an error with your request; please try again later!'
					}
				});
			}
		} );
	}

	render() {
		return (
			<div className="request-transcript">
				<CardContainer title={LABELS.transcript_overlay_title || 'Get this chat transcript in your email'} addClass="" contentAddClass="">
					<form ref="form" key="not-sent" className="transcript-form">
					<p>{LABELS.transcript_overlay_subtitle || 'Enter your email address to get the transcript:'}</p>
						<p className="form-row form-row-wide">
							<label>
								{LABELS.transcript_overlay_email_field_label || 'Enter your mail address'}
								<abbr className="required" title="required">*</abbr>
							</label>
							<span className="woocommerce-input-wrapper">
								<input required className="input-text" type="email" ref="email" pattern={`${zChat.EMAIL_REGEX.source}`} onChange={this.setEmail} onFocus={this.onFocusIn} onBlur={this.onFocusOutocusOut} onInvalid={this.onInvalid} />
							</span>
						</p>
						<p className="submit-button">
							<ActionButton addClass="btn btn-flat-green pull-right" label={LABELS.transcript_overlay_submit_button || 'Send'} onClick={this.send}/>
						</p>
					</form>
				</CardContainer>
			</div>
		);
	}
}

ChatOverlayRequestTranscript.displayName = 'ChatOverlayRequestTranscript';
ChatOverlayRequestTranscript.propTypes = {
	onSendTranscript: React.PropTypes.func
};
export default connect()(ChatOverlayRequestTranscript);


// WEBPACK FOOTER //
// ./src/components/ChatOverlayRequestTranscript.js